import { developmentPlanConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateRelationListLoading: true, data: '', error: false };

export function updateRelationListDevelopmentPlan(state = initialState, action) {

    switch (action.type) {
        case developmentPlanConstants.REQUEST_UPDATE_RELATIONLIST:
            return {
                updateRelationListLoading: true,
                data: '',
                error: false
            };
        case developmentPlanConstants.RECEIVE_UPDATE_RELATIONLIST:
        swal({
            text: 'Relations Updated Successfully',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                updateRelationListLoading: false,
                data: action.updateRelationListData,
                error: false
            };
        case developmentPlanConstants.UPDATE_RELATIONLIST_ERROR:
            return {
                updateRelationListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/developmentPlan/updateRelationList.reducer.js